<app-gallery-settings-customize-header
  title="Themes"
  location="theme-select-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

@if (customThemes()?.length) {
  <app-gallery-settings-group [title]="'Your Themes'" location="theme-select-customize">
    @for (customTheme of customThemes(); track customTheme.id) {
      <app-rounded-hover-box
        [border]="true"
        [active]="customTheme.theme | isActiveTheme: theme()"
        (click)="apply(customTheme.theme)"
      >
        <app-custom-theme-item [customTheme]="customTheme" [gallery]="gallery()"></app-custom-theme-item>
      </app-rounded-hover-box>
    }
  </app-gallery-settings-group>
}

@for (category of categories(); track $index) {
  <app-gallery-settings-group [title]="category.title" location="theme-select-customize">
    @for (categoryTheme of category.themes; track $index) {
      <app-rounded-hover-box
        [border]="true"
        [active]="categoryTheme | isActiveTheme: theme()"
        (click)="apply(categoryTheme)"
      >
        <app-theme-item [theme]="categoryTheme" [gallery]="gallery()"></app-theme-item>
      </app-rounded-hover-box>
    }
  </app-gallery-settings-group>
}
